import React from "react";
import { Box, Typography } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";

const Settings = () => {
  return (
     <Box sx={{ p: 2, pt: 1, mt: -2 }}>
           {/* HEADER */}
        <Typography variant="h5" fontWeight="bold">
        Settings
        </Typography>
  
        <Typography variant="body2" color="text.secondary" mb={2}>
        Manage your account, preferences, and personal information
        </Typography>

        <Box
          sx={{
            height: "80vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "grey.800",
          }}
        >
          <SettingsIcon sx={{ fontSize: 80, color: "grey.600", mb: 2, animation: "rotate 3s linear infinite" }} />

          <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
            Settings
          </Typography>

          <Typography variant="subtitle1" sx={{ color: "grey.600" }}>
            This feature is coming soon!
          </Typography>

          {/* Simple keyframes animation */}
          <style>
            {`
              @keyframes rotate {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </Box>
   </Box>
  );
};

export default Settings;
